// PROJECT
export const GET_ALL_PROJECTS_WAIT = 'GET_ALL_PROJECTS_WAIT';
export const GET_ALL_PROJECTS_SUCCESS = 'GET_ALL_PROJECTS_SUCCESS';
export const GET_ALL_PROJECTS_ERROR = 'GET_ALL_PROJECTS_ERROR';

export const CREATE_PROJECT_WAIT = 'CREATE_PROJECT_WAIT'
export const CREATE_PROJECT_SUCCESS = 'CREATE_PROJECT_SUCCESS'
export const CREATE_PROJECT_ERROR = 'CREATE_PROJECT_ERROR'

export const PATCH_PROJECT_WAIT = 'PATCH_PROJECT_WAIT'
export const PATCH_PROJECT_SUCCESS = 'PATCH_PROJECT_SUCCESS'
export const PATCH_PROJECT_ERROR = 'PATCH_PROJECT_ERROR'

export const DELETE_PROJECT_WAIT = 'DELETE_PROJECT_WAIT'
export const DELETE_PROJECT_SUCCESS = 'DELETE_PROJECT_SUCCESS'
export const DELETE_PROJECT_ERROR = 'DELETE_PROJECT_ERROR'

export const GET_PROJECT_WAIT = 'GET_PROJECT_WAIT'
export const GET_PROJECT_SUCCESS = 'GET_PROJECT_SUCCESS'
export const GET_PROJECT_ERROR = 'GET_PROJECT_ERROR'

export const POST_PROJECT_WAIT = 'POST_PROJECT_WAIT'
export const POST_PROJECT_SUCCESS = 'POST_PROJECT_SUCCESS'
export const POST_PROJECT_ERROR = 'POST_PROJECT_ERROR'

//CHART
export const GET_DETAIL_CHART_WAIT = 'GET_DETAIL_CHART_WAIT';
export const GET_DETAIL_CHART_SUCCESS = 'GET_DETAIL_CHART_SUCCESS';
export const GET_DETAIL_CHART_ERROR = 'GET_DETAIL_CHART_ERROR';

export const CREATE_CHART_WAIT = 'CREATE_CHART_WAIT'
export const CREATE_CHART_SUCCESS = 'CREATE_CHART_SUCCESS'
export const CREATE_CHART_ERROR = 'CREATE_CHART_ERROR'

export const UPDATE_CHART_WAIT = 'UPDATE_CHART_WAIT';
export const UPDATE_CHART_SUCCESS = 'UPDATE_CHART_SUCCESS';
export const UPDATE_CHART_ERROR = 'UPDATE_CHART_ERROR';

export const DELETE_CHART_WAIT = 'DELETE_CHART_WAIT';
export const DELETE_CHART_SUCCESS = 'DELETE_CHART_SUCCESS';
export const DELETE_CHART_ERROR = 'DELETE_CHART_ERROR';

// BUYERMAP
export const GET_ALL_BUYERMAP_WAIT = 'GET_ALL_BUYERMAP_WAIT';
export const GET_ALL_BUYERMAP_SUCCESS = 'GET_ALL_BUYERMAP_SUCCESS';
export const GET_ALL_BUYERMAP_ERROR = 'GET_ALL_BUYERMAP_ERROR';

export const DELETE_BUYERMAP_WAIT = 'DELETE_BUYERMAP_WAIT'
export const DELETE_BUYERMAP_SUCCESS = 'DELETE_BUYERMAP_SUCCESS'
export const DELETE_BUYERMAP_ERROR = 'DELETE_BUYERMAP_ERROR'

export const ADD_ROW_TO_BUYER_MAP = 'ADD_ROW_TO_BUYER_MAP';

export const UPDATE_CELL_TO_BUYER_MAP = 'UPDATE_CELL_TO_BUYER_MAP';


// STRATEGYMAP
export const GET_ALL_STRATEGYMAP_WAIT = 'GET_ALL_STRATEGYMAP_WAIT';
export const GET_ALL_STRATEGYMAP_SUCCESS = 'GET_ALL_STRATEGYMAP_SUCCESS';
export const GET_ALL_STRATEGYMAP_ERROR = 'GET_ALL_STRATEGYMAP_ERROR';

// NonCustomers
export const GET_ALL_NONCUSTOMERS_WAIT = 'GET_ALL_NONCUSTOMERS_WAIT';
export const GET_ALL_NONCUSTOMERS_SUCCESS = 'GET_ALL_NONCUSTOMERS_SUCCESS';
export const GET_ALL_NONCUSTOMERS_ERROR = 'GET_ALL_NONCUSTOMERS_ERROR';

// ERRC
export const GET_ALL_ERRC_WAIT = 'GET_ALL_ERRC_WAIT';
export const GET_ALL_ERRC_SUCCESS = 'GET_ALL_ERRC_SUCCESS';
export const GET_ALL_ERRC_ERROR = 'GET_ALL_ERRC_ERROR';

// TOBESTRATEGYMAP
export const GET_ALL_TOBESTRATEGYMAP_WAIT = 'GET_ALL_TOBESTRATEGYMAP_WAIT';
export const GET_ALL_TOBESTRATEGYMAP_SUCCESS = 'GET_ALL_TOBESTRATEGYMAP_SUCCESS';
export const GET_ALL_TOBESTRATEGYMAP_ERROR = 'GET_ALL_TOBESTRATEGYMAP_ERROR';

//auth
export const USER_LOGIN_SUCCESS = 'USER_LOGIN_SUCCESS';
export const USER_LOGIN_FAILURE = 'USER_LOGIN_FAILURE';
export const USER_LOGOUT = 'USER_LOGOUT';

export const USER_SIGNUP_SUCCESS = 'USER_SIGNUP_SUCCESS';
export const USER_SIGNUP_FAILURE = 'USER_SIGNUP_FAILURE';

//register
export const USER_REGISTER_SUCCESS = 'USER_REGISTER_SUCCESS';
export const USER_REGISTER_FAILURE = 'USER_REGISTER_FAILURE';
